import type { IconSvgObject } from './types';

const GameboyIcon: IconSvgObject = [
  ["path", { d: "M18 2H6C4.34315 2 3 3.34315 3 5V19C3 20.6569 4.34315 22 6 22H18C19.6569 22 21 20.6569 21 19V5C21 3.34315 19.6569 2 18 2Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M11 17H9M9 17L7 17M9 17L9 19M9 17L9 15", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M17 18V16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M16 6H8C7.44772 6 7 6.44772 7 7V10C7 10.5523 7.44772 11 8 11H16C16.5523 11 17 10.5523 17 10V7C17 6.44772 16.5523 6 16 6Z", stroke: "currentColor", strokeWidth: "1.5", key: "3" }]
];

export default GameboyIcon;
